/* eslint-disable */
export default {
  close: '닫기',
} as const;

// @key: @#@"close"@#@ @source: @#@"Close"@#@
